import React from 'react';

import '../../styles/flight-path/otp_modal.scss';
import PropTypes from 'prop-types';

import useI18n from '../../hooks/use-i18n';
import { LOGIN_OPTIONS, handleLineLogin } from '../../utils/flightpath/constants';

const LoginOptionsModal = ({ setLoginOptions, error }) => {
  const i18n = useI18n();
  const loginPage = i18n.t('login_page');

  return (
    <div className="otp-modal-wrapper login-modal">
      <div className="modal-overlay">
        <div className="modal-container text-center">
          <div className="content-area">
            <div className="login-text-container">
              <p>{loginPage.sign_in}</p>
              <p>{loginPage.welcome_back}</p>
              <p>{loginPage.sign_in_to_your_account}</p>
              {error && <p className="error-message">{loginPage.an_error_occurred}</p>}
            </div>
            <div className="login-buttons-container">
              <button type="button" className="button" onClick={() => setLoginOptions(LOGIN_OPTIONS.EMAIL)}>
                <img
                  src="/img/jp-home-page/icons/email.svg"
                  alt="Email"
                  width="24"
                  height="24"
                  style={{ marginRight: '8px' }}
                />
                {loginPage.sign_in_with_email}
              </button>
              <button type="button" className="button" onClick={() => setLoginOptions(LOGIN_OPTIONS.MOBILE)}>
                <img
                  src="/img/jp-home-page/icons/telephone.svg"
                  alt="Phone"
                  width="24"
                  height="24"
                  style={{ marginRight: '8px' }}
                />
                {loginPage.sign_in_with_phone}
              </button>
              <button
                type="button"
                className="button"
                onClick={handleLineLogin}
              >
                <img
                  src="/img/jp-home-page/icons/line.svg"
                  alt="LINE"
                  width="24"
                  height="24"
                  style={{ marginRight: '8px' }}
                />
                {loginPage.sign_in_with_line}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

LoginOptionsModal.propTypes = {
  error: PropTypes.string,
  setLoginOptions: PropTypes.func
};

LoginOptionsModal.defaultProps = {
  error: null,
  setLoginOptions: () => {}
};

export default LoginOptionsModal;
